export enum TableStatusEnum {
  AVAILABLE = 1,
  OCCUPIED = 2,
  LOCK = 3,
  RESERVED = 4,
}
